import { LevelData } from '../level-data';

export const level11: LevelData = {
    name: 'Precision',
    timeLimit: 95,
    track: [
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '-------',
        '---S---',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
